import {
  getAuth,
  sendSignInLinkToEmail,
  isSignInWithEmailLink,
  signInWithEmailLink,
  signOut,
  onAuthStateChanged,
  User,
  AuthError,
  ActionCodeSettings,
} from 'firebase/auth';
import app from './firebase';
import { getEnvDepVar } from './firebaseConfig';

const auth = getAuth(app);

const actionCodeSettings: ActionCodeSettings = {
  url: getEnvDepVar().url.EMAIL_LINK_URL,
  handleCodeInApp: true,
};

export const signoutUser = (): Promise<void> => signOut(auth);

/**
 * the email is handled by mailersend.com. this is in the account registered to
 * justin.h.bird@gmail.com
 *
 * In firebase we have the smtp template enabled.
 */
export const emailLinkSend = (email: string): Promise<void> =>
  sendSignInLinkToEmail(auth, email, actionCodeSettings)
    .then(() => {
      // The link was successfully sent. Inform the user.
      // Save the email locally so you don't need to ask the user for it again
      // if they open the link on the same device.
      window.localStorage.setItem('emailForSignIn', email);
    })
    .catch((error: AuthError) => {
      // TODO: Handle Error
      throw new Error(error.code);
    });

export const emailLinkVerify = (): boolean =>
  isSignInWithEmailLink(auth, window.location.href);

export const emailLinkComplete = (email: string): Promise<User | null> =>
  signInWithEmailLink(auth, email, window.location.href)
    .then((result) => {
      // Clear email from storage.
      window.localStorage.removeItem('emailForSignIn');
      // You can access the new user via result.user
      // Additional user info profile not available via:
      // result.additionalUserInfo.profile == null
      // You can check if the user is new or existing:
      // result.additionalUserInfo.isNewUser
      return result.user;
    })
    .catch((error: AuthError) => {
      // Some error occurred, you can inspect the code: error.code
      // Common errors could be invalid email and invalid or expired OTPs.
      signoutUser();
      throw new Error(error.code);
    });

export const authStateChange = (
  userSetter: React.Dispatch<React.SetStateAction<User | null | undefined>>
): (() => void) =>
  onAuthStateChanged(auth, (user) => {
    if (user) {
      userSetter(user);
    } else {
      userSetter(null);
    }
  });

export default emailLinkSend;
